// Copyright (C) 2023 Cochise Ruhulessin
// 
// All rights reserved. No warranty, explicit or implicit, provided. In
// no event shall the author(s) be liable for any claim or damages.
// 
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
import { IonButton, IonCol, IonGrid, IonRow } from "@ionic/react"

interface ContainerProps { }


const LoginContainer: React.FC<ContainerProps> = () => {
  return (
    <div className="container">
      <p>Je bent niet aangemeld bij Apparaatregistratiesysteem. Gebruik je Google-account van Molano om je aan te melden.</p>
      <IonGrid style={{marginTop: "66px"}}>
        <IonRow>
          <IonCol>
            <IonButton
              onClick={() => {
                window.location.replace("/api/oauth2/login/google")
              }}
              size="large"
            >
              Aanmelden met mijn Google-account
            </IonButton>
          </IonCol>
        </IonRow>
      </IonGrid>
    </div>
  )
}

export { LoginContainer }